"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidBrowserWindowUid = exports.isValidRequestUid = void 0;
function isValidRequestUid(val) {
    return _validResponseTargetUid(val);
}
exports.isValidRequestUid = isValidRequestUid;
function isValidBrowserWindowUid(val) {
    return _validResponseTargetUid(val);
}
exports.isValidBrowserWindowUid = isValidBrowserWindowUid;
const regexResponseTargetUid = /^[a-z0-9]{8,32}$/;
function _validResponseTargetUid(val) {
    return typeof val === 'string' &&
        regexResponseTargetUid.test(val);
}
//# sourceMappingURL=response-target-util.js.map